// extracted by mini-css-extract-plugin
module.exports = {"button":"df5dab2e92--button--jsxTC"};